import logo from './logo.svg';
import './App.css';

import compLogoImg from './imgs/logo.png';
import { useEffect, useCallback, useState } from 'react';

import toast, { Toaster } from 'react-hot-toast';

// parrallax 
import { ParallaxProvider } from 'react-scroll-parallax';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import LogoScrollGSAP from './Components/LogoScrollGSAP';
import Spacer from './Components/Spacer';
import BGColorChange from './Components/BGColorChange';
import SideMenuBar from './Components/SideMenuBar';
import ImageScrollOpacity from './Components/ImageScrollOpacity';
import ParallexText from './Components/ParallexText';
import BottomBar from './Components/BottomBar';
// main imgs 
import justiceImg from './imgs/bigImgs/justic.png';

// views
import Home from './Components/Home';
import Profile from './Components/Profile';
import NewsList from './Components/NewsList';
import MonthlySunjin from './Components/MonthlySunjin';
// lawyer list 
import LawyerLists from './Components/LawyerLists';
// special case 
import SpCase1 from './Components/SpCase1';
// routes
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Components/Layout';
gsap.registerPlugin(ScrollTrigger);

const notify = (Text) => toast.success(Text);
function App() {

  const [ViewIdx, SetViewIdx] = useState(0);

  const GetViewIdxCallBack = useCallback((ViewIdx) => {
    SetViewIdx(ViewIdx);
    console.log("Clicked on view " + ViewIdx);
    if (ViewIdx == 4) {
      notify("SNS 업데이트중입니다..");
    }

  }, [ViewIdx]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.history.scrollRestoration = 'manual';
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [ViewIdx])

  return (
    <>
      <Toaster />
      <ParallaxProvider>

        <div style={{ height: "8%" }}>
          {
            // logo 
            <LogoScrollGSAP imgsrc={compLogoImg} />
          }
        </div>
        <div style={{ display: "flex", flexDirection: "column", height: "100svh", alignItems: "center" }}>

          <div style={{ height: "95%", width: "100%" }}>

           

              <Routes>
                <Route path="/" element={<Layout />} >
                  <Route path="/" element={<Home ViewIdxCallBack={GetViewIdxCallBack} />} />
                  <Route path="/case" element={<NewsList Expanded={false} />} />
                  <Route path="/case/:caseId" element={<NewsList Expanded={true} />} />
                  <Route path="/profile" element={<Profile  />} />
                  <Route path="/ms" element={<MonthlySunjin  />} />
                  <Route path="/lawyers" element={<LawyerLists  />} />
                  <Route path="/sp-case-1" element={<SpCase1  />} />
                </Route>
              </Routes>

           
           
          </div>

        </div>
        <div style={{ height: "8%" }}>
          <BottomBar ViewIdxCallBack={GetViewIdxCallBack} />
        </div>
      </ParallaxProvider>
    </>
  );
}
/* 
<BrowserRouter>
     
      <Routes>
        <Route path="/" element={<LayOut />} >
          <Route path="/" element={<App />} />
          <Route path="success" element={<NiceSuccess />} />
          <Route path="unauthorized" element={<Unauthorized />} />
          <Route element={<PersistLogin />}>
            <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
              <Route path="/admin" element={<AdminPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
     
  </BrowserRouter>

    {ViewIdx == 0 ?
              <>

                <Home ViewIdxCallBack={GetViewIdxCallBack} />
              </>
              : null}

            {ViewIdx == 1 ?
              <>

                
                <NewsList />

              </>
              : null}

            {ViewIdx == 2 ?
              <>
                 
                <Profile />
              </>
              : null}

            {ViewIdx == 3 ?
              <>
                <div style={{ color: "white" }} >후원 </div>
              </>
              : null}

            {ViewIdx == 4 ?
              <>
                <div style={{ color: "white" }}>SNS 업데이트중~ </div>

              </>
              : null}
            {ViewIdx == 5 ?
              <>
                
                <MonthlySunjin />

              </>
              : null}
            {ViewIdx == 6 ?
              <>
                 
                <LawyerLists />

              </>
              : null}
*/
export default App;

//< BGColorChange scrHeight={60} colorTo={"101315"} speId={"startColorCh"} />